import {
    warning
} from "@jutro/logger";

export default function loadAdobeTM(adobeTMAssetURL) {
    if (!adobeTMAssetURL){
        return warning("To enable AdobeTM provide asset URL")
    }
    function addPageBottonScript() {
        const js = document.createElement('script');
        js.type = 'text/javascript';
        js.innerText = '_satellite.pageBottom()';
        document.getElementsByTagName('body').item(0).appendChild(js);
    }
    
    // This allows to inject tag manager script dynamically based on the URL
    (function(s, id){
        if (document.getElementById(id)){ return; }
        const js = document.createElement(s);
        js.id = id;
        js.onload = function(){
            addPageBottonScript();
        };
        const url = `//assets.adobedtm.com/${adobeTMAssetURL}`;
        js.src = url;
        document.getElementsByTagName('head').item(0).appendChild(js);
    }('script', 'tagManagerScript'));
}